module.exports = __webpack_public_path__ + "static/media/project_empty_circle2@2x.b7d1cd28.png";